<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" >
        <a-row :gutter="24">
          <a-col :md="10" :sm="12">
            <a-form-item label="保险公司">
              <j-search-select-tag
                placeholder="请选择保险公司"
                v-model="queryParam.companyCode"
                dict="biz_insurance_company,name,code">
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="8">
            <a-form-item label="期数">
              <a-input v-model.trim="queryParam.phase" placeholder="请输入期数"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="12">
            <a-form-item label="录入日期">
              <a-range-picker
                style="width: 210px"
                v-model="queryParam.inputDateRange"
                format="YYYY-MM-DD"
                :placeholder="['开始时间', '结束时间']"
                @change="onDateChange"
              />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="8">
            <a-form-item label="保单号">
              <a-input v-model.trim="queryParam.policyNo" placeholder="请输入保单号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="8">
            <a-form-item label="项目">
              <j-dict-select-tag v-model="queryParam.project" placeholder="请选择项目" dictCode="bms_project"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="部门" >
              <j-dict-select-tag
                placeholder="请选择部门"
                v-model="queryParam.sysOrgCode"
                dictCode="sys_depart,depart_name,org_code">
              </j-dict-select-tag>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="6">
            <a-button type="primary" @click="match" style="margin-right: 20px;" v-has="'businessinfoMatch:match'">匹配</a-button>
            <a-tooltip placement="topLeft" overlayClassName="draw_atooltip" title="开票规则：1）不选择表格任何记录，则未匹配和已匹配的数据全部开票；
              2）如果选择未匹配或已匹配表格中任意条数记录（至少1条），则只开票选择的数据； 
              3）如果只开票已匹配的全部记录，点击已匹配表格标题上的“全部开票”按钮进行快速开票；">
              <a-button type="primary" @click="invoice" v-has="'businessinfoMatch:invoice'">开票</a-button>
            </a-tooltip>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <!--<div class="table-operator">-->
      <!--&lt;!&ndash;<a-button type="primary" icon="download" @click="">导出</a-button>&ndash;&gt;-->
    <!--</div>-->

    <!-- table区域--未匹配记录区-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 10px;height: 40px;">
        <span style="float:left;" >未匹配记录</span>
        <div style="float:left; margin-left:100px;">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
          <a style="margin-left: 24px" @click="onClearSelected">清空</a>
          <a v-if="this.totalDataSource.length >0" style="margin-left: 24px" @click="exportMatchedData('0')">导出</a>
        </div>
        <span style="float:right; ">金额单位：元</span>
        <span style="float:right; margin-right:100px;">总金额：{{totalAmount}}</span>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="idWithInsuranceDataId"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap">
        <!--:rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"-->

        <template slot="colorSlot" slot-scope="text">
          <span style="color:red;">{{ !text ? '': text.toLocaleString()}}</span>
        </template>
        <template slot="rataioColorSlot" slot-scope="text">
          <span style="color:red;">{{ !text ? '': text + '%' }}</span>
        </template>
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
        </template>

        <span slot="action" slot-scope="text, record">
          <!--<a @click="handleDetail(record)">详情</a>-->
        </span>
      </a-table>
      <div>
        <a-pagination
        style="margin-top:10px;float:right;"
        size="middle"
        v-model="ipagination.current"
        :pageSize="ipagination.pageSize"
        :pageSizeOptions="ipagination.pageSizeOptions"
        :total="ipagination.total"
        @change="pageNumberOrSizeChange"
        @showSizeChange="pageNumberOrSizeChange"
        showSizeChanger
        showQuickJumper
      />
      </div>
    </div>

    <!-- table区域--已匹配记录区-begin -->
    <div style="margin-top:50px;">
      <div class="ant-alert ant-alert-info" style="margin-bottom: 10px;height: 40px;">
        <span style="float:left;">已匹配记录</span>
        <div style="float:left; margin-left:100px;">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys2.length }}</a>项
          <a style="margin-left: 24px" @click="onClearSelected2">清空</a>
          <a v-if="this.totalDataSource2.length >0" style="margin-left: 24px" @click="matchedInvoiceAll">全部开票</a>
          <a v-if="this.totalDataSource2.length >0" style="margin-left: 24px" @click="exportMatchedData('1')">导出</a>
        </div>
        <span style="float:right; ">金额单位：元</span>
        <span style="float:right; margin-right:100px;">总金额：{{totalAmount2}}</span>
      </div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource2"
        :pagination="false"
        :rowSelection="{selectedRowKeys: selectedRowKeys2, onChange: onSelectChange2}"
        class="j-table-force-nowrap">
        <template slot="colorSlot" slot-scope="text">
          <span style="color:red;">{{ !text ? '': text.toLocaleString() }}</span>
        </template>
        <template slot="rataioColorSlot" slot-scope="text">
          <span style="color:red;">{{ !text ? '': text + '%' }}</span>
        </template>

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <!--<span slot="action" slot-scope="text, record">-->
          <!--<a @click="handleInvoice(record)">开票</a>-->
        <!--</span>-->

      </a-table>
      <a-pagination
        style="margin-top:10px;float:right;"
        size="middle"
        v-model="ipagination2.current"
        :pageSize="ipagination2.pageSize"
        :pageSizeOptions="ipagination2.pageSizeOptions"
        :total="ipagination2.total"
        @change="pageNumberOrSizeChange2"
        @showSizeChange="pageNumberOrSizeChange2"
        showSizeChanger
        showQuickJumper
      />
    </div>

    <!--<biz-invoiceinfo-modal ref="modalForm" @ok="modalFormOk"></biz-invoiceinfo-modal>-->
  </a-card>
</template>

<script>
  import { getAction, postAction} from '@/api/manage'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import AFormItem from 'ant-design-vue/es/form/FormItem'
  import APagination from 'ant-design-vue/es/pagination'
  import JSearchSelectTag from "@/components/dict/JSearchSelectTag"
  import {export_array_to_excel} from '@/utils/excel'

  export default {
    name: 'BizBusinessinfoMatch',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      AFormItem,
      APagination,
      JSearchSelectTag,
    },
    data () {
      return {
        disableMixinCreated: true,//禁止初始加载
        queryParam: {
          companyCode:'',
          policyNo:'',
          phase:'',
          project:'',
          inputDateRange:[]
        },
        lastQueryParam:{}, //最后一次匹配的条件
        description: '业绩匹配',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'业绩编号',
            align:"center",
            dataIndex: 'businessNumber'
          },
          {
            title:'日期',
            align:"center",
            dataIndex: 'date',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'经纪人',
            align:"center",
            dataIndex: 'broker',
            sorter: true
          },
          {
            title:'佣金',
            className:'column-money',
            dataIndex: 'brokerageTotal',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          {
            title:'佣金(保司)',
            className:'column-money',
            dataIndex: 'e_brokerageTotal',
            scopedSlots: { customRender: 'colorSlot' }
          },
          {
            title:'投保人',
            className:'column-text',
            dataIndex: 'insure'
          },
          {
            title:'被保险人',
            className:'column-text',
            dataIndex: 'insured'
          },
          {
            title:'保险人',
            className:'column-text',
            dataIndex: 'insurer'
          },
          {
            title:'车牌号',
            align:"center",
            dataIndex: 'car'
          },
          {
            title:'保险起期',
            align:"center",
            dataIndex: 'insuranceStart',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'保险讫期',
            align:"center",
            dataIndex: 'insuranceEnd',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'保单号',
            className:'column-text',
            dataIndex: 'policy'
          },
          {
            title:'保额',
            className:'column-money',
            dataIndex: 'insuredAmount',
            customRender:function (text) {
              return !text ? '': Number(text).toLocaleString()
            }
          },
          {
            title:'费率',
            className:'column-money',
            dataIndex: 'rate',
            customRender:function (text) {
              return !text ? '' : text + '‰'
            }
          },
          {
            title:'保费',
            className:'column-money',
            dataIndex: 'premium',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          {
            title:'去税保费',
            className:'column-money',
            dataIndex: 'cleanPremium',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          {
            title:'佣金比例',
            className:'column-money',
            dataIndex: 'brokerageRatio',
            customRender:function (text) {
              return !text ? '' : text + '%'
            }
          },
          {
            title:'佣金比例(保司)',
            className:'column-money',
            dataIndex: 'e_brokerageRatio',
            scopedSlots: { customRender: 'rataioColorSlot' }
          },
          {
            title:'期数',
            align:"center",
            dataIndex: 'phase'
          },
          {
            title:'期数(保司)',
            align:"center",
            dataIndex: 'e_phase',
            scopedSlots: { customRender: 'colorSlot' }
          },
          // {
          //   title:'开票比例',
          //   className:'column-money',
          //   dataIndex: 'invoiceRatio',
          //   customRender:function (text) {
          //     return !text ? '' : text + '%'
          //   }
          // },

        ],

        totalAmount:'0.00',
        totalAmount2: '0.00',
        totalDataSource:[],
        totalDataSource2:[],
        dataSource2:[],
        /* 分页参数 */
        ipagination2:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['5','10', '50', '100','1000'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " 共" + total + "条"
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        selectedRowKeys2: [],
        /* table选中records*/
        selectionRows2: [],

        url: {
          match: "/bms/bizBusinessinfo/math",
          invoice: "/bms/invoiceOperation/pushInvoice"
        },
      }
    },
    created() {
    },
    computed: {
      // userInfo() {
      //   return this.$store.getters.userInfo
      // }
    },
    methods: {
      getQueryParams() {
        //检查参数是否已填写
        if(this.queryParam.companyCode == null || this.queryParam.companyCode ===""){
          this.$message.warn('请选择保险公司!')
          return false;
        }
        if(this.queryParam.phase == null || this.queryParam.phase ===""){
          this.$message.warn('请输入期数!')
          return false;
        }
        if(this.queryParam.inputDateRange === null || this.queryParam.inputDateRange.length == 0){
          this.$message.warn('请选择录入日期!')
          return false;
        }
        if((this.queryParam.project == null || this.queryParam.project ==="")&&
          (this.queryParam.sysOrgCode == null || this.queryParam.sysOrgCode ==="")){
          this.$message.warn('项目以及部门需选择其一!')
          return false;
        }

        let sqp = {}
        this.lastQueryParam = Object.assign({}, this.queryParam); //保存查询条件值

        var param = Object.assign(sqp, this.queryParam)
        param.startDate = this.queryParam.inputDateRange[0] + ' 00:00:00';
        param.endDate = this.queryParam.inputDateRange[1] + ' 23:59:59';
        delete param.inputDateRange;

        return param;
      },

      onDateChange: function (value, dateString) {
        this.queryParam.inputDateRange = dateString;
      },

      //匹配过程： 先匹配，然后返回结果
      match(){
        this.clearDataSource();
        var params = this.getQueryParams();//查询条件
        if(!params){
          return;
        }

        this.loading = true;
        getAction(this.url.match, params).then((res) => {
          if (res.success) {
            if(res.result.unMath != null){
              this.totalDataSource = res.result.unMath;
              this.ipagination.pageSize = 10;
              this.ipagination.current = 1;
              this.ipagination.total = res.result.unMath.length;
              this.totalAmount = !res.result.unMatchTotal ? '0.00': res.result.unMatchTotal.toLocaleString();
              this.dataSource = this.getShowSource(this.totalDataSource, this.ipagination);
            }
            if(res.result.math != null){ //已匹配的
              this.totalDataSource2 = res.result.math;
              this.ipagination2.pageSize = 10;
              this.ipagination2.current = 1;
              this.ipagination2.total = res.result.math.length;
              this.totalAmount2 = !res.result.matchTotal ? '0.00': res.result.matchTotal.toLocaleString();
              this.dataSource2 = this.getShowSource(this.totalDataSource2, this.ipagination2);
            }
          } else {
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      clearDataSource(){
        this.totalDataSource = [];
        this.totalDataSource2 = [];
        this.dataSource = []
        this.dataSource2 = []
        this.totalAmount = '0.00';
        this.totalAmount2 = '0.00';
        this.onClearSelected();
        this.onClearSelected2();
      },

      //已匹配选择项改变
      onSelectChange2(selectedRowKeys, selectionRows) {
        this.selectedRowKeys2 = selectedRowKeys;
        this.selectionRows2 = selectionRows;
      },
      onClearSelected2(){
        this.selectedRowKeys2 = [];
        this.selectionRows2 = [];
      },
      pageNumberOrSizeChange(current, size){
        this.ipagination.current = current;
        this.ipagination.pageSize = size;
        this.dataSource = this.getShowSource(this.totalDataSource, this.ipagination);
      },
      pageNumberOrSizeChange2(current, size){
        this.ipagination2.current = current;
        this.ipagination2.pageSize = size;
        this.dataSource2 = this.getShowSource(this.totalDataSource2, this.ipagination2);
      },
      //实现分页效果
      getShowSource(totalDataSource, ipagination) {
        var keyValue = 0;
        var data = totalDataSource;//后端返回的全部数据
        for (var i = 0; i < data.length; i++) {
          keyValue = keyValue + 1;
          let key = { key: keyValue };
          data[i] = Object.assign(data[i], key);
        }
        var start = ipagination.pageSize * ipagination.current - ipagination.pageSize;
        var end = ipagination.pageSize * ipagination.current;
        return data.slice(start, end);
      },

      //开票
      invoice(){
        if(this.totalDataSource.length <=0 && this.totalDataSource2.length <=0){
          this.$message.warning("没有业绩记录，无法开票")
          return;
        }
        //判断条件是否被修改
        if(JSON.stringify(this.lastQueryParam) != JSON.stringify(this.queryParam)){
          this.$message.warning("条件已被修改，请重新匹配")
          return;
        }

        let idObj = {selectedIds: '', insuranceDataIds: ''}
        let selectedIds = '';
        let insuranceDataIds = ''; // 保司数据id
        let idRelation = []; //业绩id与保司数据id对应关系
        if(this.selectedRowKeys.length >0){
          this.selectedRowKeys.forEach(
            item => {
              this.getIdRelation(item, idObj, idRelation)
            }
          )
        }
        if(this.selectedRowKeys2.length >0){
          this.this.selectedRowKeys.forEach(
            item =>{
              this.getIdRelation(item, idObj, idRelation)
            }
          )
        }

        if(idObj.selectedIds.length >0){ // 按选择业绩进行开票
        } else { // 全部开票
          this.totalDataSource.forEach(
            item => {
              this.getIdRelation(item.idWithInsuranceDataId, idObj, idRelation)
            }
          )
          this.totalDataSource2.forEach(
            item => {
              this.getIdRelation(item.idWithInsuranceDataId, idObj, idRelation)
            }
          )
        }

        let params = {
          startDate: this.queryParam.inputDateRange[0] + ' 00:00:00',
          endDate: this.queryParam.inputDateRange[1] + ' 23:59:59',
          companyCode: this.queryParam.companyCode,
          project: this.queryParam.project,
          phase: this.queryParam.phase
        }

        idObj.selectedIds = idObj.selectedIds.substr(0, idObj.selectedIds.length-1)
        params.idList = idObj.selectedIds
        idObj.insuranceDataIds = idObj.insuranceDataIds.substr(0, idObj.insuranceDataIds.length-1)
        params.insuranceDataIdList = idObj.insuranceDataIds
        params.idRelation = idRelation

        postAction(this.url.invoice, params).then((res) => {
          if(res.success) {
            this.$message.info("开票成功")
            this.clearDataSource();
          } else {
            this.$message.warning(res.message)
          }
        })
      },

      getIdRelation(item, idObj, idRelation){
        let id = ""
        let insuranceDataId = ""
        if(item.includes("#")){ // #分隔业绩id和保司数据id
          id = item.split("#")[0]
          insuranceDataId = item.split("#")[1]
        } else{
          id = item
        }

        idObj.selectedIds += id + ','
        if(insuranceDataId){
          idObj.insuranceDataIds += insuranceDataId + ','
        }
        idRelation.push({businessInfoId: id, insuranceBillId: insuranceDataId})
      },

      // 已匹配业绩全部开票， 因全选按钮只能选择当前页面的数据，不是所有数据，单独加此功能
      matchedInvoiceAll(){
        if(this.totalDataSource2.length <=0){
          this.$message.warning("没有已匹配的业绩记录，无法开票")
          return;
        }
        //判断条件是否被修改
        if(JSON.stringify(this.lastQueryParam) != JSON.stringify(this.queryParam)){
          this.$message.warning("条件已被修改，请重新匹配")
          return;
        }
        // 清除当前的选择
        this.onClearSelected();
        this.onClearSelected2();

        let that = this
        this.$confirm({
          title:'提示',
          content:'将已匹配的' + that.totalDataSource2.length + '条业绩全部开票，是否继续？',
          onOk(){
            that.doMatchedInvoiceAll(that)
          },
          onCancel(){
          }
        })
      },
      doMatchedInvoiceAll(that){
        let selectedIds = '';  // 业绩id
        let insuranceDataIds = ''; // 保司数据id
        let idRelation = []; //业绩id与保司数据id对应关系

        that.totalDataSource2.forEach(
          item =>{
            selectedIds += item.id + ','
            insuranceDataIds += item.insuranceDataId + ','
            idRelation.push({businessInfoId: item.id, insuranceBillId: item.insuranceDataId})
          }
        )

        let params = {
          startDate: that.queryParam.inputDateRange[0] + ' 00:00:00',
          endDate: that.queryParam.inputDateRange[1] + ' 23:59:59',
          companyCode: that.queryParam.companyCode,
          project: that.queryParam.project,
          phase: that.queryParam.phase
        }

        if(selectedIds.length > 0){
          selectedIds = selectedIds.substr(0, selectedIds.length-1)
          params.idList = selectedIds

          insuranceDataIds = insuranceDataIds.substr(0, insuranceDataIds.length-1)
          params.insuranceDataIdList = insuranceDataIds
          params.idRelation = idRelation
        }

        postAction(that.url.invoice, params).then((res) => {
          if(res.success){
            that.$message.info("开票成功")
            that.clearDataSource();
          }else{
            that.$message.warning(res.message)
          }
        })
      },

      // 导出未/已匹配数据
      exportMatchedData(type){
        let titles = ['业绩编号','日期','经纪人','佣金','佣金(保司)','投保人','被保险人','保险人','车牌号','保险起期','保险讫期','保单号','保额','费率','保费','去税保费','佣金比例','佣金比例(保司)','期数','期数(保司)','开票比例'];
        let keys = ['businessNumber','date','broker','brokerageTotal','e_brokerageTotal','insure','insured','insurer','car','insuranceStart','insuranceEnd','policy','insuredAmount','rate','premium','cleanPremium', 'brokerageRatio','e_brokerageRatio', 'phase','e_phase','invoiceRatio'];
        let dataSource = null
        let fileName = ''

        if(type == '0'){
          dataSource = this.dataSource;
          fileName = "未匹配数据"
        } else {
          dataSource = this.totalDataSource2
          fileName = "已匹配数据"
        }

        const param = {
          title: titles,
          key: keys,
          data: dataSource,
          autoWidth: true,
          filename: fileName
        };
        export_array_to_excel(param);
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
  th.column-money {
    text-align: center !important;
  }
  td.column-money {
    text-align: right !important;
  }

  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
</style>